export default [
  { name: 'name', title: 'Nachname' },
  { name: 'surname', title: 'Name' },
  { name: 'start_date', title: 'Startdatum' },
];
